// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.GetRenterRentDetailsByInviteTokenHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite,
  GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_Path,
} from '@zg-rentals/ts-rent-payment-client';

import type {
  GetRentDetailsFromInviteRequestDto,
  GetRentDetailsFromInviteResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export type GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_Options = UseQueryOptions<
  GetRentDetailsFromInviteResponseDto,
  unknown,
  GetRentDetailsFromInviteResponseDto,
  Array<string | GetRentDetailsFromInviteRequestDto>
>;

const GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_GetKey = (
  postData: GetRentDetailsFromInviteRequestDto,
) => [GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_Path, postData];

/**
 * Get rent details from encrypted invite token
 */
export const useGetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite = (
  postData: GetRentDetailsFromInviteRequestDto,
  {
    httpClient,
    ...options
  }: Omit<GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_GetKey(postData),
    queryFn: () => GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite(postData, httpClient),
  });
};
useGetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite.getKey =
  GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_GetKey;
